<template>
    <div>
        <navbar></navbar>

        <div>
            <!--      <sidebar></sidebar>-->
            <section id="main-content">
                <div class="container-fluid">
                    <div style="height: 20px"></div>
                    <div class="main-content" style="padding-left: 0; padding-right: 0">
                        <router-view></router-view>
                    </div>

                    <div style="height: 20px"></div>
                </div>
            </section>
        </div>
        <footer class="footer">
            <div class="container" style="text-align: center; line-height: 2">
                <span class="muted mobile-footer"
                    >hilarion 5 IT Solutions &nbsp;&copy; 2016 - {{ year }}
                    <a href="https://hilarion5.com" target="_blank">hilarion 5</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a
                        href="https://hilarion5.com/datenschutzmitteilung/"
                        target="_blank"
                        >Datenschutz</a
                    >&nbsp;&nbsp;|&nbsp;&nbsp;<a href="https://hilarion5.com/kontakt/" target="_blank">Impressum</a>
                </span>
                <span class="muted mobile-footer-show"
                    >hilarion 5 IT Solutions &nbsp;&copy; 2016 - {{ year }} <br />
                    <a href="https://hilarion5.com" target="_blank">hilarion 5</a><br /><a href="https://hilarion5.com/datenschutzmitteilung/" target="_blank"
                        >Datenschutz</a
                    >&nbsp;&nbsp;|&nbsp;&nbsp;<a href="https://hilarion5.com/kontakt/" target="_blank">Impressum</a>
                </span>
            </div>
        </footer>
    </div>
</template>

<script>
import navbar from './app/navigation/navbar';

export default {
    name: 'App',
    components: {
        navbar,
    },
    data() {
        return {
            year: new Date().getFullYear(),
            registration: null,
        };
    },
    mounted: function () {},
    created() {
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.getRegistrations().then((registrations) => {
                for (let registration of registrations) {
                    registration.unregister().then((success) => {
                        if (success) {
                            console.log('Service worker unregistered');
                        }
                    });
                }
            });
        }
    },
};
</script>

<style></style>

<i18n>
  {
  "de": {
  },
  "en": {
  }
  }
</i18n>
